module.exports = __webpack_public_path__ + "static/media/elcorteingles.7a56ad99.webp";